if (!window.serbajadiNavigationReady) {
  window.serbajadiNavigationReady = true;
  document.addEventListener('toggle', (event) => {
    const group = event.target;
    if (group.matches?.('.sj-mobile-nav')) {
      group.querySelector(':scope > summary').setAttribute('aria-label',group.open?'Close navigation menu':'Open navigation menu');
      if(group.open) (group.querySelector('.sj-mobile-language button[aria-pressed="true"]') || group.querySelector('.sj-mobile-panel summary'))?.focus();
      return;
    }
    if (!group.matches?.('.sj-nav-group') || !group.open) return;
    group.parentElement.querySelectorAll(':scope > .sj-nav-group').forEach(other => { if (other !== group) other.open = false; });
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('.sj-desktop-nav .sj-nav-group[open]').forEach(group => { if (!group.contains(event.target)) group.open = false; });
    if(event.target.closest('.sj-mobile-panel a')) document.querySelectorAll('.sj-mobile-nav[open]').forEach(drawer=>drawer.open=false);
  });
  document.addEventListener('keydown',event=>{
    const activeDrawer=document.querySelector('.sj-mobile-nav[open]');
    if(event.key==='Tab'&&activeDrawer){
      const controls=[...activeDrawer.querySelectorAll('summary,a,button')].filter(el=>el.getClientRects().length);
      const first=controls[0],last=controls.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
    if(event.key!=='Escape') return;
    const drawer=document.querySelector('.sj-mobile-nav[open]');
    if(drawer){drawer.open=false;drawer.querySelector('summary').focus();}
    else document.querySelectorAll('.sj-desktop-nav .sj-nav-group[open]').forEach(group=>{group.open=false;group.querySelector('summary').focus();});
  });
}
